var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mx-32 mt-4"},[_c('h2',[_vm._v(_vm._s(_vm.$t("customers.label.PaymentPage")))]),_c('div',{attrs:{"id":"component-container"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }